import { render, staticRenderFns } from "./pending-prescription-hist-details-button.vue?vue&type=template&id=48b691cf&lang=pug&"
import script from "./pending-prescription-hist-details-button.vue?vue&type=script&lang=ts&"
export * from "./pending-prescription-hist-details-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports